/**
 * Favorites service for handling favorite-related operations
 */

import axiosClient from "../../config/axiosClient";
import { ENDPOINTS } from "../../config/endpoints";
import { FavoriteResponse, FavoritesListResponse } from "./favorites.types";
import { parseFavoritesListPayload } from "./parseFavoritesListResponse";

class FavoritesService {
  /**
   * Add a product to favorites
   */
  async addFavorite(productId: string): Promise<FavoriteResponse> {
    const response = await axiosClient.post<FavoriteResponse>(
      ENDPOINTS.FAVORITES.add(productId)
    );
    return response.data;
  }

  /**
   * Remove a product from favorites
   */
  async removeFavorite(productId: string): Promise<{ message: string; success: boolean }> {
    const response = await axiosClient.delete<{ message: string; success: boolean }>(
      ENDPOINTS.FAVORITES.remove(productId)
    );
    return response.data;
  }

  /**
   * Get all favorites for the current buyer
   */
  async getFavorites(): Promise<FavoritesListResponse> {
    const response = await axiosClient.get<unknown>(ENDPOINTS.FAVORITES.BASE);
    return parseFavoritesListPayload(response.data);
  }
}

// Export singleton instance
export const favoritesService = new FavoritesService();
export default favoritesService;













